import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import {
    CCard, CModal,
    CCardBody, CModalHeader,
    CButton, CModalBody,
    CCardHeader, CDropdown,
    CCol, CLabel,
    CDataTable, CTextarea,
    CRow, CForm, CFormGroup,
    CPagination, CFormText,
} from 'compat/coreui'

import axios from 'axios';
import moment from 'moment';
import { postData } from '../../../helpers/api';
import { ToastContainer, toast } from 'react-toastify';
import ChartLineSimple from '../charts/ChartLineSimple';
import ChartBarSimple from '../charts/ChartBarSimple';
import PreOrdersChart from '../charts/PreOrdersChart.js';
import Chart from '../charts/Charts.js';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import { addDays, subDays } from 'date-fns';
import { CChartLine } from '@coreui/react-chartjs';


const PreOrder = () => {
    const history = useNavigate()
    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [orderStatus, setOrderStatus] = useState('pending');
    const [orderId, setOrderId] = useState("");
    const [pendingOrders, setPendingOrders] = useState(0);
    const [completedOrders, setCompletedOrders] = useState(0);
    const [onTheWayOrders, setOnTheWayOrders] = useState(0);
    const [cancelledOrders, setCancelledOrders] = useState(0);
    const [processingOrders, setProcessingOrders] = useState(0);
    const [filerDays, setFilerDays] = useState(10);
    const [modal, setModal] = useState(false);

    const toggle = (id) => {
        // e.preventDefault()
        setModal(!modal);
        setOrderId(id)
    }
    const [state, setState] = useState({
        selection1: {
            startDate: moment(new Date()).subtract(10, "days"),
            endDate: addDays(new Date(), 0),
            key: 'selection1'
        }
        // selection2: {
        //     startDate: addDays(new Date(), 4),
        //     endDate: addDays(new Date(), 8),
        //     key: 'selection2'
        // },
        // selection3: {
        //     startDate: addDays(new Date(), 8),
        //     endDate: addDays(new Date(), 10),
        //     key: 'selection3',
        //     autoFocus: false
        // }
    });
    useEffect(async () => {
        getData()
    }, [])

    function getData() {
        let URL = `${process.env.REACT_APP_APP_API_URL}/api/order?startDate=${moment(state.selection1.startDate).format('YYYY-MM-DD')}&endDate=${moment(state.selection1.endDate).format('YYYY-MM-DD')}&filter=1`;
        console.log("URL==>> ", URL);
        axios.get(URL, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then(async res => {
            setOrderData(res.data.formatedData)
            let revenue = 0;
            revenue = await orderData.reduce((total, obj) => obj.price + total, 0)
            setTotalRevenue(await orderData.reduce((total, obj) => obj.price + total, 0));
            let completed = res.data.formatedDataStatus.Completed;
            setCompletedOrders(completed ? completed : 0)
            let processing = res.data.formatedDataStatus.Processing
            setProcessingOrders(processing ? processing : 0)
            let pending = res.data.formatedDataStatus.Pending;
            setPendingOrders(pending ? pending : 0)
            let theway = res.data.formatedDataStatus.OnTheWay;
            setOnTheWayOrders(theway ? theway : 0)
            let cancled = res.data.formatedDataStatus.Cancelled;
            setCancelledOrders(cancled ? cancled : 0)
        }).catch(e => console.log(e))
    }

    const getPriceSymbol = type => {
        switch (type) {
            case 'price':
                return 'g'
            case 'priceHalf':
                return '1/2'
            case 'priceForth':
                return '1/4'
            case 'priceEight':
                return '1/8'
            case 'priceOz':
                return 'oz'
        }
    }

    const statusHandler = (e) => {
        e.preventDefault();
        console.log('handler', orderStatus, orderData, orderId)
        const data = {
            "orderId": orderId,
            "status": orderStatus
        }
        postData(`${process.env.REACT_APP_APP_API_URL}/api/order/status`, data).then(res => {
            if (res.data.status) {
                setModal(false);
                toast.success('Order status changed successfully');
                getData();
            }
        }).catch(console.log)

    }
    const handleSelect = () => {
        let selectedDatys = moment(state.selection1.endDate).diff(moment(state.selection1.startDate), "days")
        console.log("selectedDatys> ", selectedDatys);
        // getData();
        return selectedDatys;
    }

    return (
        <>
            <CModal
                show={modal}
            >
                <DateRangePicker
                    onChange={item => setState({ ...state, ...item })}
                    ranges={[state.selection1]}
                />;
            </CModal>
            <CRow>
                <CCol className="mb-5" lg={6}>
                    <span>Pre-Orders</span>
                </CCol>
                <CCol className="text-right mb-5" lg={6}>
                    <CButton style={{ background: "#2eb85c", color: "white", marginRight: "1px" }} onClick={() => toggle()}>{handleSelect()} Days Filer</CButton>
                </CCol>
            </CRow>
            <CRow className="text-center" style={{ width: "100%" }}>
                <CCol md sm="12" className="mb-sm-2 mb-0">
                    <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                        <div className="text-muted text-center" style={{ fontWeight: "600" }} >Total Revenue</div>
                        <div>
                            <strong style={{ color: "black", fontSize: "240%", marginRight: "0px" }}></strong>
                            <strong style={{ color: "black", fontSize: "240%" }}>{orderData.reduce((total, obj) => obj.price + total, 0)}</strong>
                        </div>
                    </CCard>
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0">
                    <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                        <div className="text-muted text-center" style={{ fontWeight: "600" }} >Orders</div>
                        <div>
                            <strong style={{ color: "black", fontSize: "240%", marginRight: "0px" }}></strong>
                            <strong style={{ color: "black", fontSize: "240%" }}>{orderData.length}</strong>
                        </div>

                    </CCard>
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0">
                    <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                        <div className="text-muted text-center" style={{ fontWeight: "600" }} >Completion Rate</div>
                        <div>
                            <strong style={{ color: "black", fontSize: "240%", marginRight: "0px" }}></strong>
                            <strong style={{ color: "black", fontSize: "240%" }}>{(completedOrders / (pendingOrders + completedOrders + cancelledOrders + onTheWayOrders + processingOrders) * 100).toFixed(2)}%</strong>
                        </div>
                    </CCard>
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0">
                    <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                        <div className="text-muted text-center" style={{ fontWeight: "600" }} >Average Spend</div>
                        <div>
                            <strong style={{ color: "black", fontSize: "240%", marginRight: "0px" }}></strong>
                            <strong style={{ color: "black", fontSize: "240%" }}>{((pendingOrders + completedOrders + cancelledOrders + onTheWayOrders + processingOrders) / completedOrders).toFixed(2)}</strong>
                        </div>

                    </CCard>
                </CCol>
            </CRow>
            <CCardBody>
                <CRow>
                    {/*<CButton style={{ background: "#2eb85c", color: "white", marginRight: "1px" }} onClick={() => toggle()}>10 Days Filer</CButton>*/}
                    <CCol lg={12} className="p-0">
                        <CCard>
                            <CCardHeader>Revenue Per Day</CCardHeader>
                            <CCardBody>
                                <PreOrdersChart />
                                <CRow>
                                    <CCol lg={12}>
                                        <span className="increase-order">
                                            <span>
                                                <i className="fa fa-shopping-cart"></i>
                                            </span>
                                            <span>
                                                <p>Looking to increase your orders? <Link to="/contact" className="contact-link">Contact us</Link> to learn how!</p>
                                            </span>
                                        </span>
                                    </CCol>
                                </CRow>
                                <CRow className="mt-5 analytics-pre-order ">
                                    <CCol lg={6}>
                                        <CCard>
                                            <CCardHeader style={{ fontSize: "120%" }} className="category_header">
                                                Recent Order History
                                            </CCardHeader>
                                            <CCardBody>
                                                <div>
                                                    <table className="table table-striped table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Orders</th>
                                                                <th>Revenue</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {orderData.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{new Date(item.name).getMonth() + "-" + new Date(item.name).getDate() + "-" + new Date(item.name).getFullYear()}</td>
                                                                        <td>{item.count}</td>
                                                                        <td>${item.price}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                    <CCol lg={6}>
                                        <CCard>
                                            <CCardHeader className="category_header">
                                                Day of Week
                                            </CCardHeader>
                                            <CCardBody>
                                                <CChartLine
                                                    datasets={[
                                                        {
                                                            label: 'Number of orders',
                                                            backgroundColor: '#58c863',
                                                            data: [39, 80, 40, 35, 40, 20, 45],
                                                        },

                                                    ]}
                                                    options={{
                                                        tooltips: {
                                                            enabled: true
                                                        }
                                                    }}
                                                    labels={['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat']}
                                                />
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                                <CRow className="mt-5 analytics-pre-order ">
                                    <CCol lg={6}>
                                        <CCard>
                                            <CCardHeader className="category_header">
                                                Average Order Size
                                            </CCardHeader>
                                            <CCardBody>
                                                <CChartLine
                                                    datasets={[
                                                        {
                                                            label: 'Dollar Value',
                                                            backgroundColor: 'rgb(228,102,81,0.9)',
                                                            // backgroundColor: 'transparent',
                                                            data: "",
                                                        },

                                                    ]}
                                                    options={{
                                                        tooltips: {
                                                            enabled: true
                                                        }
                                                    }}
                                                    labels={['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat']}
                                                />
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                    <CCol lg={6}>
                                        <CCard>
                                            <CCardHeader className="category_header">
                                                Time of Day
                                            </CCardHeader>
                                            <CCardBody>
                                                <CChartLine
                                                    datasets={[
                                                        {
                                                            label: '',
                                                            // backgroundColor: 'rgb(228,102,81,0.9)',
                                                            backgroundColor: 'transparent',
                                                            borderTop: "1px solid green",
                                                            data: "",
                                                        },

                                                    ]}
                                                    options={{
                                                        tooltips: {
                                                            enabled: true
                                                        }
                                                    }}
                                                    labels={['12a', '1a', '2a', '3a', '4a', '5a', '6a', '7a', '8a', '9a', '10a', '11a', '12p', '1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p', '10p', '11p']}
                                                />
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CCardBody>


        </>

    )
}

export default PreOrder;
